import { Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { RadarPage } from './pages/RadarPage';

/**
 * Code-based route tree (no file-based codegen step).
 *
 * There is only one screen today. The map's position lives in the query string
 * and is written directly to history (see `lib/viewport-url.ts`) rather than
 * through the router, because it changes on every pan and shouldn't re-render
 * the tree.
 */
const rootRoute = createRootRoute({ component: Outlet });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: RadarPage,
});

const routeTree = rootRoute.addChildren([indexRoute]);

export const router = createRouter({ routeTree });

// Register the router instance for full type inference on Links/navigation.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
